"use strict";
var appn;
(function (appn) {
    var elementBuilder;
    (function (elementBuilder) {
        function buildAppnSelect(items, id, classes, allText, name) {
            if (name)
                name = ` name="${name}"`;
            let itemsHtml = `<select id="${id}" class="form-control-sm form-control ${classes}"${name ? name : appn.emptyString}>`;
            if (allText)
                itemsHtml += `<option value = "" >${allText}</option>`;
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                itemsHtml += '<option ';
                if (item.hasOwnProperty('DataTag') && item.dataTag) {
                    itemsHtml += item.dataTag;
                    if (item.hasOwnProperty('DataValue') && item.dataValue)
                        itemsHtml += `="${selectOptionCleanup(item.dataValue)}" `;
                }
                if (item.hasOwnProperty('DataTag2') && item.dataTag2) {
                    itemsHtml += item.dataTag2;
                    if (item.hasOwnProperty('DataValue2') && item.dataValue2)
                        itemsHtml += `="${selectOptionCleanup(item.dataValue2)}" `;
                }
                if (item.hasOwnProperty('DataTag3') && item.dataTag3) {
                    itemsHtml += item.dataTag3;
                    if (item.hasOwnProperty('DataValue3') && item.dataValue3)
                        itemsHtml += `="${selectOptionCleanup(item.dataValue3)}" `;
                }
                let selected = appn.emptyString;
                if (item.selected)
                    selected = ' selected="selected"';
                itemsHtml += ` value="${item.value}"${selected}>${item.text}</option>`;
            }
            itemsHtml += '</select>';
            return itemsHtml;
        }
        elementBuilder.buildAppnSelect = buildAppnSelect;
        function buildSelectGeneric(items, id, classes, allText, name, additionalStyle) {
            let styleText = appn.emptyString;
            if (additionalStyle && additionalStyle !== appn.emptyString)
                styleText = ` style="${additionalStyle}"`;
            let nameText = appn.emptyString;
            if (name && name !== appn.emptyString)
                nameText = ` name=${name}`;
            let itemsHtml = `<select id="${id}"${styleText}${nameText} class="${classes}">`;
            if (allText && allText !== appn.emptyString)
                itemsHtml += `<option value = "" >${allText}</option>`;
            if (appn.utils.hasValue(items))
                for (let i = 0; i < items.length; i++) {
                    let selected = appn.emptyString;
                    const item = items[i];
                    if (item.selected)
                        selected = ' selected="selected"';
                    itemsHtml += `<option value="${item.value}"${selected}>${item.text}</option>`;
                }
            itemsHtml += '</select>';
            return itemsHtml;
        }
        elementBuilder.buildSelectGeneric = buildSelectGeneric;
        function buildSelect(items, id, classes, allText, name, additionalStyle) {
            let styleText = appn.emptyString;
            if (additionalStyle && additionalStyle !== appn.emptyString)
                styleText = ` style="${additionalStyle}"`;
            let nameText = appn.emptyString;
            if (name && name !== appn.emptyString)
                nameText = ` name=${name}`;
            let itemsHtml = `<select id="${id}"${styleText}${nameText} class="form-control-sm form-control ${classes}">`;
            if (allText && allText !== appn.emptyString)
                itemsHtml += `<option value = "" >${allText}</option>`;
            if (appn.utils.hasValue(items))
                for (let i = 0; i < items.length; i++) {
                    let selected = appn.emptyString;
                    const item = items[i];
                    if (item.selected)
                        selected = ' selected="selected"';
                    itemsHtml += `<option value="${item.value}"${selected}>${item.text}</option>`;
                }
            itemsHtml += '</select>';
            return itemsHtml;
        }
        elementBuilder.buildSelect = buildSelect;
        function buildOptionsListSelectList(items, allText, optGroupInjector) {
            let optionsHtml = appn.emptyString;
            if (allText)
                optionsHtml += `<option value = "" >${allText}</option>`;
            items.forEach(function (item, index) {
                if (optGroupInjector && optGroupInjector.groupName) {
                    if (index === optGroupInjector.startIndex)
                        optionsHtml += `<optgroup label="${optGroupInjector.groupName}">`;
                    if (index === optGroupInjector.endIndex)
                        optionsHtml += `</optgroup>`;
                }
                optionsHtml += `<option value="${item.Value}">${item.Text}</option>`;
            });
            return optionsHtml;
        }
        elementBuilder.buildOptionsListSelectList = buildOptionsListSelectList;
        function buildOptionsList(items, allText) {
            let optionsHtml = appn.emptyString;
            if (allText)
                optionsHtml += `<option value = "" >${allText}</option>`;
            items.forEach(function (item, index) {
                optionsHtml += `<option value="${item}">${item}</option>`;
            });
            return optionsHtml;
        }
        elementBuilder.buildOptionsList = buildOptionsList;
        function buildArraySelect(items, id, classes, allText, name) {
            if (name)
                name = ` name="${name}"`;
            let itemsHtml = `<select style="margin-left: 0.5em;" id="${id}" class="form-control-sm form-control ${classes}"${name ? name : appn.emptyString}>`;
            itemsHtml += buildOptionsList(items, allText);
            itemsHtml += '</select>';
            return itemsHtml;
        }
        elementBuilder.buildArraySelect = buildArraySelect;
        function buildTaskStatusSelect(statuses, id, classes) {
            let itemsHtml = `<select id="${id}" class="form-control-sm form-control ${classes}">
                <option value="All">${T("ALL STATUSES")}</option>
                <option value="AllIncomplete">${T("ALL INCOMPLETE")}</option>`;
            for (let i = 0; i < statuses.length; i++)
                itemsHtml += `<option class="" value="${statuses[i].Value}">${statuses[i].Display}</option>`;
            itemsHtml += '</select>';
            return itemsHtml;
        }
        elementBuilder.buildTaskStatusSelect = buildTaskStatusSelect;
        function buildCheckbox(text, inputClasses, id, color, name, includeHiddenInput, isChecked) {
            return `<div class="icheck-${color ? color : ICheckColor.primary} appn-checkbox"><input class="${(inputClasses ? inputClasses : appn.emptyString)}" type="checkbox" id="${(id ? id : appn.emptyString)}">${(includeHiddenInput ? `<input name="${name}" type="hidden" value="${(isChecked ? 'true' : 'false')}">` : appn.emptyString)}<label for="${(id ? id : appn.emptyString)}">${(text ? text : appn.emptyString)}</label></div>`;
        }
        elementBuilder.buildCheckbox = buildCheckbox;
        function buildCheckboxWithHint(text, hint, inputClasses, id, color, name, includeHiddenInput, isChecked) {
            return `<div class="icheck-${color ? color : ICheckColor.primary} appn-checkbox"><input class="${(inputClasses ? inputClasses : appn.emptyString)}" type="checkbox" id="${(id ? id : appn.emptyString)}">${(includeHiddenInput ? `<input name="${name}" type="hidden" value="${(isChecked ? 'true' : 'false')}">` : appn.emptyString)}
                    <label for="${(id ? id : appn.emptyString)}">
                        <span data-widget="popover" data-trigger="manual" data-html="true" data-placement="top" data-content="${(hint ? hint : appn.emptyString)} " data-original-title="" title="">
                            <span>${(text ? text : appn.emptyString)}</span>
                            <i class="fa fa-question-circle"></i>
                        </span>
                    </label>
                </div>`;
        }
        elementBuilder.buildCheckboxWithHint = buildCheckboxWithHint;
        function buildCardHideButton(classes, attributes) {
            return `<button type="button" class="btn btn-tool card-btn-expand-or-collapse ${(classes ? classes : appn.emptyString)}" ${(attributes ? attributes : appn.emptyString)} ><i class="fas fa-times"></i></button>`;
        }
        elementBuilder.buildCardHideButton = buildCardHideButton;
        function buildBtnRemoveRow(classes, attributes) {
            return `<button type="button" class="btn-remove-row btn btn-outline-danger btn-icon-round btn-sm float-right ${(classes ? classes : appn.emptyString)}" ${(attributes ? attributes : appn.emptyString)}><i class="fa fa-times"></i></button>`;
        }
        elementBuilder.buildBtnRemoveRow = buildBtnRemoveRow;
        function buildBtnMoveRow(isUpDirection, classes, attributes) {
            const direction = isUpDirection ? 'up' : 'down';
            return `<button type="button" class="btn-move-${direction} btn btn-outline-secondary btn-icon-round ${direction}_button btn-sm ${(classes ? classes : appn.emptyString)}" ${(attributes ? attributes : appn.emptyString)}><i class="fa fa-chevron-${direction}"></i></button>`;
        }
        elementBuilder.buildBtnMoveRow = buildBtnMoveRow;
        function buildIconButton(formulaType) {
            return `<button ${formulaType ? `data-type="${formulaType}"` : appn.emptyString} class="fa fa-hammer btn btn-secondary buildIcon" type="button"><i></i></button>`;
        }
        elementBuilder.buildIconButton = buildIconButton;
        function buildLinkBtn(text, link, classes, id) {
            return `<a href="${link}" id="${id}" class="btn ${classes}">${text}</a>`;
        }
        elementBuilder.buildLinkBtn = buildLinkBtn;
        function buildLinkTag(text, link, classes, id) {
            return `<a href="${link}" id="${id}" class="btn btn-link ${classes}">${text}</a>`;
        }
        elementBuilder.buildLinkTag = buildLinkTag;
        function selectOptionCleanup(dataValue) {
            return dataValue
                .replace('\r\n', appn.emptyString)
                .replace('\r', appn.emptyString)
                .replace('\n', appn.emptyString)
                .replace('\t', appn.emptyString).trim();
        }
        function createElement(tagName, className, id, attributes, innerHTML, includeEmptyAtrributes = false) {
            const element = document.createElement(tagName);
            if (className)
                if (Array.isArray(className))
                    element.className = className.join(' ');
                else
                    element.className = className;
            if (id)
                element.id = id;
            if (attributes && Array.isArray(attributes) && attributes.length > 0)
                joinAttributes(attributes).forEach((attribute) => {
                    if (includeEmptyAtrributes || attribute[1] !== appn.emptyString)
                        element.setAttribute(attribute[0], attribute[1]);
                });
            if (innerHTML)
                element.innerHTML = innerHTML;
            return element;
        }
        elementBuilder.createElement = createElement;
        function getSimpleInputFor(className, name, id, type, placeholder, value, required = false, checked = false) {
            const textInput = document.createElement('input');
            if (className)
                if (Array.isArray(className))
                    textInput.className = className.join(' ');
                else
                    textInput.className = className;
            if (name)
                textInput.name = name;
            if (id)
                textInput.id = id;
            if (type)
                textInput.type = type;
            if (placeholder)
                textInput.placeholder = placeholder;
            if (value)
                textInput.value = value.toString();
            textInput.required = required;
            if (type === HTMLInputType.CheckBox)
                textInput.checked = checked;
            return textInput;
        }
        elementBuilder.getSimpleInputFor = getSimpleInputFor;
        function getIconFor(className, attributes, includeEmptyAtrributes = false) {
            const icon = document.createElement('i');
            icon.className = className;
            if (attributes && Array.isArray(attributes) && attributes.length > 0)
                joinAttributes(attributes).forEach((attribute) => {
                    if (includeEmptyAtrributes || attribute[1] !== appn.emptyString)
                        icon.setAttribute(attribute[0], attribute[1]);
                });
            return icon;
        }
        elementBuilder.getIconFor = getIconFor;
        function getHiddenIndexerFor(name, value, addPrefix = true) {
            const indexInput = document.createElement('input');
            indexInput.type = HTMLInputType.Hidden;
            indexInput.name = `${name}.Index`;
            indexInput.value = addPrefix ? `new-${value}` : value.toString();
            return indexInput;
        }
        elementBuilder.getHiddenIndexerFor = getHiddenIndexerFor;
        function joinAttributes(attributes) {
            const filteredAttributes = attributes.map(item => item[0]).filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            const joinedAttributes = [];
            filteredAttributes.forEach((attrName) => {
                const attr = attributes.filter((attribute, index, self) => {
                    return attribute[0] === attrName;
                });
                const values = [];
                attr.forEach((currentAttr) => {
                    values.push(currentAttr[1]);
                });
                joinedAttributes.push([attrName, values.join(' ')]);
            });
            return joinedAttributes;
        }
        function getSelectListFor(type, values, display, className, name, id, displayTextSpacePlaceholder, required = false) {
            const selectInput = document.createElement('select');
            if (className)
                if (Array.isArray(className))
                    selectInput.className = className.join(' ');
                else
                    selectInput.className = className;
            if (name)
                selectInput.name = name;
            if (id)
                selectInput.id = id;
            if (type === HTMLElementType.SelectMulti)
                selectInput.multiple = true;
            selectInput.required = required;
            values.forEach((value, index) => {
                let displayText = display[index];
                if (displayTextSpacePlaceholder)
                    displayText = display[index].replace(displayTextSpacePlaceholder, ' ');
                const option = document.createElement('option');
                option.value = value;
                option.text = displayText;
                selectInput.appendChild(option);
            });
            return selectInput;
        }
        elementBuilder.getSelectListFor = getSelectListFor;
        function getDateTimePickerFor(type, className, name, id, placeholder, value, required = false) {
            let iconClass = 'fa';
            switch (type) {
                case HTMLElementType.Date:
                case HTMLElementType.DateTime: {
                    iconClass += ' fa-calendar fa-xs';
                    break;
                }
                case HTMLElementType.Time: {
                    iconClass += ' fa-clock fa-xs';
                    break;
                }
            }
            const groupAddonButton = createElement('button', 'input-group-text btn btn-secondary', undefined, [['type', 'button']]);
            groupAddonButton.appendChild(createElement('i', iconClass));
            const groupAddon = createElement('div', 'input-group-append input-group-addon');
            groupAddon.appendChild(groupAddonButton);
            const input = getSimpleInputFor(className, name, id, HTMLInputType.Text, undefined, undefined, required);
            const container = createElement('div', `input-group date ${type.toLowerCase()}picker`);
            container.appendChild(input);
            container.appendChild(groupAddon);
            return container;
        }
        elementBuilder.getDateTimePickerFor = getDateTimePickerFor;
        function getNewRow(select, dataName, dataValue, presetId, type = RowType.Default, dataNamesUsed) {
            const presetTableBody = $(`#fields_${presetId} tbody`);
            const option = type !== RowType.Page ? $(`option[value="${dataName}"]`) : $(`optgroup[label="${dataName}"]`);
            const parentName = option.attr('parent');
            const questionText = option.data('qt');
            const parentRow = $(`#fields_${presetId} tbody #${parentName}`);
            const hasParentRow = parentRow.length > 0 ? true : false;
            const id = option.data('index');
            let level = 0;
            let rowClass = '';
            if (type === RowType.Default) {
                level = Number(option.attr('level'));
                rowClass = 'preset-page-child';
                if (level === 1)
                    rowClass = 'preset-table-child';
            }
            if (type === RowType.Table)
                rowClass = 'preset-table-header';
            if (type === RowType.Page)
                rowClass = 'preset-page-header';
            const row = elementBuilder.createElement('tr', rowClass, undefined, [['data-index', id], ['parent', parentName !== null && parentName !== void 0 ? parentName : appn.emptyString]]);
            switch (type) {
                case RowType.Page: {
                    const cellPageHeader = elementBuilder.createElement('td', undefined, undefined, [['colspan', '4']]);
                    cellPageHeader.appendChild(elementBuilder.createElement('h4', undefined, undefined, undefined, `${questionText} (${dataName})`));
                    row.appendChild(cellPageHeader);
                    row.id = dataName;
                    break;
                }
                case RowType.Table: {
                    if (!hasParentRow)
                        presetTableBody.append(getNewRow(select, parentName, false, presetId, RowType.Page, dataNamesUsed));
                    const requiredInputHidden = elementBuilder.getSimpleInputFor(undefined, `Template.Presets[${presetId}].Fields[${id}].DataName`, `Template__Presets_${presetId}__Fields_${id}__DataName`, elementBuilder.HTMLInputType.Hidden, undefined, dataName);
                    const cellTableHeader = elementBuilder.createElement('td', undefined, undefined, [['colspan', '4']]);
                    cellTableHeader.appendChild(elementBuilder.getHiddenIndexerFor(`Template.Presets[${presetId}].Fields`, id, false));
                    cellTableHeader.appendChild(elementBuilder.createElement('h4', undefined, undefined, undefined, `${questionText} (${dataName})`));
                    cellTableHeader.appendChild(requiredInputHidden);
                    row.appendChild(cellTableHeader);
                    row.id = dataName;
                    break;
                }
                case RowType.Default: {
                    if (!hasParentRow) {
                        const preset = dataNamesUsed[Number(presetId)];
                        let isSet = false;
                        if (preset && preset.length > 0)
                            preset.forEach(function (dataSet, index) {
                                const dataName = dataSet.split('|')[0];
                                const dataValue = dataSet.split('|')[1].toBooleanExact();
                                if (dataName === parentName)
                                    isSet = dataValue;
                            });
                        presetTableBody.append(getNewRow(select, parentName, isSet, presetId, level === 0 ? RowType.Page : RowType.Table, dataNamesUsed));
                    }
                    const cellDataName = elementBuilder.createElement('td', undefined, undefined, undefined, dataName);
                    row.appendChild(cellDataName);
                    const cellQuestionText = elementBuilder.createElement('td', undefined, undefined, undefined, questionText);
                    row.appendChild(cellQuestionText);
                    const requiredInputHidden = elementBuilder.getSimpleInputFor(undefined, `Template.Presets[${presetId}].Fields[${id}].DataName`, `Template__Presets_${presetId}__Fields_${id}__DataName`, elementBuilder.HTMLInputType.Hidden, undefined, dataName);
                    const requiredInput = elementBuilder.buildCheckbox('', 'task-template-preset-required', `Template__Presets_${presetId}__Fields_${id}__Required`, elementBuilder.ICheckColor.primary, `Template.Presets[${presetId}].Fields[${id}].Required`, true, dataValue);
                    const cellRequired = elementBuilder.createElement('td', 'dataCol');
                    cellRequired.append(elementBuilder.getHiddenIndexerFor(`Template.Presets[${presetId}].Fields`, id, false));
                    cellRequired.append(requiredInputHidden);
                    cellRequired.append(requiredInput.toHtmlElement());
                    row.appendChild(cellRequired);
                    const actionIcon = elementBuilder.buildBtnRemoveRow('delete_button', `data-index="" data-name="${dataName}"`);
                    const cellAction = elementBuilder.createElement('td', 'closeCell');
                    cellAction.append(actionIcon.toHtmlElement());
                    row.append(cellAction);
                    break;
                }
            }
            return row;
        }
        elementBuilder.getNewRow = getNewRow;
        let HTMLInputType;
        (function (HTMLInputType) {
            HTMLInputType["Text"] = "text";
            HTMLInputType["Number"] = "number";
            HTMLInputType["Hidden"] = "hidden";
            HTMLInputType["CheckBox"] = "checkbox";
        })(HTMLInputType = elementBuilder.HTMLInputType || (elementBuilder.HTMLInputType = {}));
        let HTMLElementType;
        (function (HTMLElementType) {
            HTMLElementType["Date"] = "Date";
            HTMLElementType["DateTime"] = "DateTime";
            HTMLElementType["Time"] = "Time";
            HTMLElementType["SelectOne"] = "SelectOne";
            HTMLElementType["SelectMulti"] = "SelectMulti";
            HTMLElementType["Text"] = "Text";
            HTMLElementType["Decimal"] = "Decimal";
            HTMLElementType["Integer"] = "Integer";
            HTMLElementType["Long"] = "Long";
            HTMLElementType["Hidden"] = "Hidden";
            HTMLElementType["Boolean"] = "Boolean";
            HTMLElementType["Rest"] = "Rest";
        })(HTMLElementType = elementBuilder.HTMLElementType || (elementBuilder.HTMLElementType = {}));
        let RowType;
        (function (RowType) {
            RowType["Page"] = "Page";
            RowType["Table"] = "Table";
            RowType["Default"] = "Default";
        })(RowType = elementBuilder.RowType || (elementBuilder.RowType = {}));
        let ICheckColor;
        (function (ICheckColor) {
            ICheckColor["primary"] = "primary";
            ICheckColor["success"] = "success";
            ICheckColor["info"] = "info";
            ICheckColor["warning"] = "warning";
            ICheckColor["danger"] = "danger";
            ICheckColor["default"] = "default";
        })(ICheckColor = elementBuilder.ICheckColor || (elementBuilder.ICheckColor = {}));
    })(elementBuilder = appn.elementBuilder || (appn.elementBuilder = {}));
})(appn || (appn = {}));
